/**
 * Global Archive Ritual Hooks
 * Handles archive/unarchive operations for rituals at the global (creator) level.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import { archiveRitual, unarchiveRitual } from "../services/ritual.service"

export function useArchiveRitual() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (ritualId: string) => archiveRitual(ritualId),
    onSuccess: () => {
      toast.success("Ritual archived")
      queryClient.invalidateQueries({
        predicate: query => {
          const key = query.queryKey[0] as string | undefined
          return (
            key === "user-ritual-teachings" ||
            key === "user-ritual-practices" ||
            key === "user-ritual-coachings"
          )
        },
      })
    },
    onError: () => {
      toast.error("Failed to archive ritual")
    },
  })
}

export function useUnarchiveRitual() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (ritualId: string) => unarchiveRitual(ritualId),
    onSuccess: () => {
      toast.success("Ritual unarchived")
      queryClient.invalidateQueries({
        predicate: query => {
          const key = query.queryKey[0] as string | undefined
          return (
            key === "user-ritual-teachings" ||
            key === "user-ritual-practices" ||
            key === "user-ritual-coachings"
          )
        },
      })
    },
    onError: () => {
      toast.error("Failed to unarchive ritual")
    },
  })
}
